/** Copy the specified text to clipboard.
 *
 * @returns promise that resolves to true after the value was copied (or false if it was empty)
 */
export async function copyTextToClipboard(text: string | null): Promise<boolean> {
    return text ? navigator.clipboard.writeText(text).then(() => true) : false;
}
